module.exports = __webpack_public_path__ + "assets/img/icon_calendar_color.69e77fb6.svg";